import {
  sanitizeText,
  sanitizeNumber,
  sanitizeEmail,
  sanitizePhone,
  sanitizePostcode,
} from "../sanitisers/sanitisers";
import { getInputValue } from "../normalisers/getInputValue";

/* ----------------------- Factories ------------------------- */
export const makeHandleChange =
  (setFormData, setErrors) =>
  (section, field, type = "text") =>
  (raw) => {
    let clean = getInputValue(raw);
    switch (type) {
      case "number":
        clean = sanitizeNumber(clean);
        break;
      case "email":
        clean = sanitizeEmail(clean);
        break;
      case "phone":
        clean = sanitizePhone(clean);
        break;
      case "postcode":
        clean = sanitizePostcode(clean);
        break;
      default:
        clean = sanitizeText(clean);
    }

    setFormData((prev) => ({
      ...prev,
      [section]: { ...(prev[section] || {}), [field]: clean },
    }));

    setErrors((prev) => {
      if (!prev?.[section]?.[field]) return prev;
      return {
        ...prev,
        [section]: { ...(prev[section] || {}), [field]: undefined },
      };
    });
  };

/** Toggle a root-level boolean e.g. contactClient */
export const makeRootToggle = (setFormData) => (field) => () =>
  setFormData((p) => ({ ...p, [field]: !p[field] }));

/** Radio change for idDoc.type */
export const makeIdDocChange = (setFormData, setErrors) => (value) => {
  setFormData((prev) => ({ ...prev, idDoc: { ...prev.idDoc, type: value } }));
  setErrors((prev) => {
    const copy = { ...prev };
    if (copy?.idDoc?.type) copy.idDoc = { ...copy.idDoc, type: undefined };
    return copy;
  });
};

export const makeDobChange = (setFormData, setErrors) => (val) => {
  setFormData((prev) => ({
    ...prev,
    personal: { ...prev.personal, dob: val || "" },
  }));
  setErrors((prev) => ({
    ...prev,
    personal: {
      ...(prev.personal || {}),
      dob: val ? undefined : prev?.personal?.dob,
    },
  }));
};

export const makePhoneChange = (setFormData, setErrors) => (val) => {
  setFormData((prev) => ({
    ...prev,
    personal: { ...prev.personal, phone: val || "" },
  }));
  setErrors((prev) => ({
    ...prev,
    personal: {
      ...(prev.personal || {}),
      phone: val ? undefined : `+ ${prev?.personal?.phone}`,
    },
  }));
};
